import PropTypes from 'prop-types'
import { useContext } from 'react'

import theme from 'theme'

import { AccordionContext } from './Accordion'

export default function Header({ children, onClick, ...rest }) {
  const { expanded, disabled } = useContext(AccordionContext)

  return (
    <div
      css={[
        {
          display: 'flex',
          padding: theme.space[4],
          cursor: onClick && !disabled ? 'pointer' : 'unset'
        },
        Boolean(expanded) && {
          borderBottom: theme.border.base
        }
      ]}
      onClick={onClick}
      {...rest}
    >
      {children}
    </div>
  )
}

Header.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func
}
